import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-sub-menu-icon',
  templateUrl: './sub-menu-icon.component.html',
  styleUrls: ['./sub-menu-icon.component.less']
})
export class SubMenuIconComponent implements OnInit {

  dropdown = false;
  toggleMenuClicked = false;
  @Input() listMenu: string[] = [];
  @Output() menuChoice = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }

  onClickOutside(event: any) {
    if (this.dropdown && !this.toggleMenuClicked) {
      this.dropdown = false;
    }
    this.toggleMenuClicked = false;
  }

  toggleDropdown() {
    this.toggleMenuClicked = true;
    this.dropdown = !this.dropdown;
  }

  onClicked(choosedMenu: string) {
    this.menuChoice.emit(choosedMenu);
    this.dropdown = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/box-view-version/sub-menu/sub-menu-icon.component.ts